import styled from 'styled-components';

export const DicomViewerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #1a1a1a;
  color: white;
`;

export const ViewerContent = styled.div`
  flex: 1;
  overflow: hidden;
  position: relative;
`;

export const ViewerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;

export const ViewerControls = styled.div`
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
`;

export const ControlsPanel = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  padding: 16px;
  border-radius: 8px;
  backdrop-filter: blur(8px);
  margin-top: 8px;
  min-width: 250px;
`;

export const ControlGroup = styled.div`
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const GlobalStyle = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
`;
